import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field--autocomplete" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ItemList = _resolveComponent("ItemList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
                'field--autocomplete__wrapper',
                _ctx.isListOpen ? 'expanded' : '',
                _ctx.model.length ? 'valid' : '',
                _ctx.isEmpty ? 'has-error' : '',
                _ctx.hasStoreError ? 'has-error' : '',
            ])
    }, [
      _createVNode(_component_Field, {
        modelValue: _ctx.model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.model = $event)),
        name: _ctx.name,
        type: _ctx.type,
        disabled: _ctx.disabled,
        "handles-error": _ctx.handlesError,
        placeholder: _ctx.placeholder,
        "handles-data-preload": _ctx.handlesDataPreload,
        suggestions: false,
        "is-validated": false,
        "label-shows-valid": false,
        "street-filter": true,
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.blur($event))),
        onFocus: _ctx.focus,
        onClick: _ctx.open,
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.input($event))),
        onIsValid: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setIsValid($event))),
        onDataPreloadComplete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterItemList($event)))
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["modelValue", "name", "type", "disabled", "handles-error", "placeholder", "handles-data-preload", "onFocus", "onClick"]),
      _createVNode(_component_ItemList, {
        key: "itemList",
        "is-default-open": _ctx.isListOpen,
        "item-list": _ctx.displayedItemList,
        class: "fs-13",
        onSelectOption: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectValue($event.value)))
      }, null, 8, ["is-default-open", "item-list"])
    ], 2)
  ]))
}